module.exports = __webpack_public_path__ + "img/logo-euro_finans.6098996e.svg";